import { useRouter } from 'vue-router'

// 验证 token 有效性
export const validateToken = async () => {
  try {
    const token = localStorage.getItem('token')
    if (!token) {
      console.log('Token 不存在，无法验证')
      return false
    }

    console.log('开始验证 token:', token.substring(0, 20) + '...')

    // 尝试调用后端 API 验证 token（如果存在的话）
    try {
      const response = await fetch('/api/auth/validate', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      console.log('Token 验证 API 响应状态:', response.status)

      if (response.ok) {
        const data = await response.json()
        console.log('Token 验证 API 响应数据:', data)
        return data.valid === true
      } else {
        console.log('Token 验证 API 响应失败:', response.status, response.statusText)
      }
    } catch (apiError) {
      console.log('Token 验证 API 调用失败，使用本地验证:', apiError.message)
    }

    // 如果 API 不存在或失败，使用本地验证
    // 检查 token 格式是否正确（至少包含一些字符）
    if (token.length < 10) {
      console.log('Token 格式不正确，长度过短')
      return false
    }

    // 检查 token 是否包含有效字符
    if (!/^[A-Za-z0-9\-._~+/]+=*$/.test(token)) {
      console.log('Token 格式不正确，包含无效字符')
      return false
    }

    console.log('Token 本地验证通过')
    return true
  } catch (error) {
    console.error('Token 验证过程中发生错误:', error)
    return false
  }
}

// 检查管理员权限
export const checkAdminAccess = async () => {
  console.log('=== 开始检查管理员权限 ===')
  
  // 首先检查 token 是否存在
  const token = localStorage.getItem('token')
  if (!token) {
    console.log('❌ Token 不存在，重定向到登录页')
    return { success: false, redirect: '/auth', reason: 'no_token' }
  }
  console.log('✅ Token 存在:', token.substring(0, 20) + '...')

  // 验证 token 有效性
  console.log('🔄 开始验证 token 有效性...')
  const isTokenValid = await validateToken()
  if (!isTokenValid) {
    console.log('❌ Token 无效，清除数据并重定向到登录页')
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    return { success: false, redirect: '/auth', reason: 'invalid_token' }
  }
  console.log('✅ Token 验证通过')

  // 检查 token 是否过期（如果有过期时间的话）
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    console.log('📅 用户信息中的过期时间:', user.expiresAt)
    
    if (user.expiresAt && new Date() > new Date(user.expiresAt)) {
      console.log('❌ Token 已过期，清除数据并重定向到登录页')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      return { success: false, redirect: '/auth', reason: 'expired_token' }
    }
    console.log('✅ Token 未过期')
  } catch (error) {
    console.error('❌ 解析用户信息失败:', error)
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    return { success: false, redirect: '/auth', reason: 'parse_error' }
  }

  // 从 store 或 localStorage 获取用户信息
  let currentUser
  try {
    // 尝试从 store 获取用户信息
    if (window.store && window.store.state && window.store.state.user) {
      currentUser = window.store.state.user
    } else {
      currentUser = JSON.parse(localStorage.getItem('user') || '{}')
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
    currentUser = {}
  }

  console.log('👤 当前用户信息:', currentUser)

  // 检查用户信息是否完整
  if (!currentUser.username || !currentUser.id) {
    console.log('❌ 用户信息不完整，重定向到登录页')
    console.log('用户名:', currentUser.username)
    console.log('用户ID:', currentUser.id)
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    return { success: false, redirect: '/auth', reason: 'incomplete_user_info' }
  }
  console.log('✅ 用户信息完整')

  // 检查是否为管理员：只有特殊ID和超级管理员角色
  const isAdmin = currentUser.role === 'super_admin' ||
                 currentUser.id === 100000

  console.log('🔐 管理员权限检查结果:', isAdmin)
  console.log('用户角色:', currentUser.role)
  console.log('角色为super_admin:', currentUser.role === 'super_admin')
  console.log('用户ID为100000:', currentUser.id === 100000)

  if (!isAdmin) {
    console.log('❌ 权限不足，重定向到首页')
    return { success: false, redirect: '/', reason: 'insufficient_permissions' }
  }
  
  console.log('✅ 管理员权限验证通过')
  console.log('=== 管理员权限检查完成 ===')
  return { success: true, user: currentUser }
}

// 计算 token 验证间隔
const calculateValidationInterval = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    if (user.expiresAt) {
      const now = new Date()
      const expiresAt = new Date(user.expiresAt)
      const timeUntilExpiry = expiresAt.getTime() - now.getTime()
      
      // 如果 token 即将过期（小于30分钟），每5分钟检查一次
      if (timeUntilExpiry < 30 * 60 * 1000) {
        return 5 * 60 * 1000 // 5分钟
      }
      // 如果 token 还有较长时间（大于1小时），每30分钟检查一次
      else if (timeUntilExpiry > 60 * 60 * 1000) {
        return 30 * 60 * 1000 // 30分钟
      }
      // 其他情况，每15分钟检查一次
      else {
        return 15 * 60 * 1000 // 15分钟
      }
    }
  } catch (error) {
    console.error('计算验证间隔失败:', error)
  }
  
  // 默认30分钟
  return 30 * 60 * 1000
}

// 定期检查 token 有效性
export const startTokenValidation = (router, intervalMs = null) => {
  // 如果没有指定间隔，自动计算
  if (!intervalMs) {
    intervalMs = calculateValidationInterval()
  }
  
  console.log(`启动 Token 验证，间隔: ${Math.round(intervalMs / 60000)} 分钟`)
  
  const tokenCheckInterval = setInterval(async () => {
    const isTokenValid = await validateToken()
    if (!isTokenValid) {
      console.log('Token 已失效，重定向到登录页')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      router.push('/auth')
      clearInterval(tokenCheckInterval)
    } else {
      // 重新计算下次验证间隔（因为时间可能已经变化）
      const newInterval = calculateValidationInterval()
      if (newInterval !== intervalMs) {
        console.log(`调整验证间隔: ${Math.round(intervalMs / 60000)} 分钟 -> ${Math.round(newInterval / 60000)} 分钟`)
        clearInterval(tokenCheckInterval)
        startTokenValidation(router, newInterval)
      }
    }
  }, intervalMs)
  
  return tokenCheckInterval
}

// 清理认证数据
export const clearAuthData = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  console.log('认证数据已清理')
}

// 检查用户是否已登录
export const isLoggedIn = () => {
  const token = localStorage.getItem('token')
  const user = localStorage.getItem('user')
  return !!(token && user)
}

// 获取当前用户信息
export const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}')
  } catch (error) {
    console.error('解析用户信息失败:', error)
    return {}
  }
}
